import React, { useEffect, useState } from "react";
import { MarketTableHeaderListItems, MarketTableHeaderLists } from "../styles";
import MarketTableTopHeader from "../MarketTableTopHeader";
import MarketTableTopHeaderTitle from "../MarketTableTopHeaderTitle";
import MarketTableHeaderListsItems from "../MarketTableHeaderListsItems";
import { loadData } from "@utils/api";
import { COLORS } from "@app/constants";
import { useTranslation } from "react-i18next";

const MarketTableTopGainer = () => {
  const { t } = useTranslation();
  const [data, setData] = useState([]);
  useEffect(() => {
    loadData().then((res) => {
      setData(res.slice(0, 3));
    });
  }, []);
  return (
    <MarketTableHeaderLists style={{ paddingInline: 10 }}>
      <MarketTableHeaderListItems>
        <MarketTableTopHeaderTitle title={t("topGainers")} />
        <MarketTableTopHeader
          name={t("pairs")}
          amount={t("price")}
          rate={t("24HChange")}
        />
        {data.map((item, index) => (
          <MarketTableHeaderListsItems
            key={index.toString()}
            item={item}
            index={index}
            amountColor={COLORS.gray}
            rateColor={COLORS.lightGreen}
          />
        ))}
      </MarketTableHeaderListItems>
    </MarketTableHeaderLists>
  );
};

export default React.memo(MarketTableTopGainer);
